const EventTypeEnum = {
    None: "None",
    Operation: "Operation",
    BeyableScenario: "BeyableScenario",
    NationalEvent: "NationalEvent"
};

export default EventTypeEnum;
